
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "./../../../assets/images/advanced-laser1.jpg";

import "./advancedhair.css";
//bannerimg
import laser1 from "./../../../assets/images/advanced-laser.jpg";
//before and after
import laser2 from "./../../../assets/images/advanced-laser2.jpg";
import laser3 from "./../../../assets/images/advanced-laser3.jpg";
import laser4 from "./../../../assets/images/advanced-laser4.jpg";

// Import icons
import groHairIcon from "./../../../assets/images/grow-hair treatment-icons.png";
import prpIcon from "./../../../assets/images/prp-treatment-icons1.png";
import gfcIcon from "./../../../assets/images/gfc-treatment-icons.png";
import stmIcon from "./../../../assets/images/treatment.png";
import laserIcon from "./../../../assets/images/laserhair.png";
      import AutoScrollImageRow from "./AutoScrollImageRow";


const treatments = [
  { name: "GROHAIR TREATMENT", navName: "GROHAIR" },
  { name: "PRP TREATMENT", navName: "PRP" },
  { name: "GFC TREATMENT", navName: "GFC" },
  { name: "STM TREATMENT", navName: "STM" },
  { name: "LASER TREATMENT", navName: "LASER" },
];

const treatmentIconPNGMap = {
  GROHAIR: groHairIcon,
  PRP: prpIcon,
  GFC: gfcIcon,
  STM: stmIcon,
  LASER: laserIcon,
};

const images = [
  { src: laser2, alt: "Before and After Results" },
  { src: laser3, alt: "Treatment Procedure" },
  { src: laser4, alt: "Advanced Equipment" },
  // Add more images as needed
];

function Laserhair() {
  const [activeTab, setActiveTab] = useState("LASER TREATMENT");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Laser Hair Treatment in India | Advanced Laser Hair Regrowth Therapy - H-Cura";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Boost hair regrowth with Laser Hair Treatment at H-Cura. A safe, non-invasive therapy to reduce hair loss and stimulate hair follicles. Book your consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "Laser hair treatment in Bangalore,Best laser therapy for hair regrowth,Low-level laser therapy for hair loss,Non-invasive hair restoration Bangalore,Advanced laser hair regrowth treatment,Hair thinning solution with laser,Effective laser therapy for hair loss,Laser hair treatment clinic Bangalore,"
      );
    }
    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/advanced-laser-treatment");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/advanced-laser-treatment");
      document.head.appendChild(canonicalLink);
    }

    // Get the current path from window.location
    const path = window.location.pathname;

    // Extract the treatment name from the path
    const pathSegments = path.split("/");
    const currentPage = pathSegments[pathSegments.length - 1]?.toLowerCase();

    // Find the matching treatment based on the URL path
    if (currentPage) {
      const matchingTreatment = treatments.find(
        (treatment) => treatment.navName.toLowerCase() === currentPage
      );

      if (matchingTreatment) {
        setActiveTab(matchingTreatment.name);
      }
    }

    // Original effect code for process steps
    const steps = document.querySelectorAll(".hc-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const renderTreatmentIcon = (name, fallbackIcon) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : (
      fallbackIcon
    );
  };

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  // Updated handleTreatmentClick function with the new URL pattern
  const handleTreatmentClick = (treatment) => {
    setActiveTab(treatment.name);
    // Map treatment names to specific URLs
    const treatmentUrlMap = {
      "GROHAIR TREATMENT": "/advanced-grow-hair-treatment",
      "PRP TREATMENT": "/advanced-hair-prp-treatment",
      "GFC TREATMENT": "/advanced-hair-gfc-treatment",
      "STM TREATMENT": "/advanced-stm-treatment",
      "LASER TREATMENT": "/advanced-laser-treatment"
    };
    
    // Use the mapped URL if available, otherwise fallback to the original pattern
    const url = treatmentUrlMap[treatment.name] || `/home/${treatment.navName.toLowerCase()}`;
    console.log("Navigating to:", url); // Debug log
    navigate(url);
  };

  return (
    <div className="hc-wrapper">
      {/* New Navigation Section */}
      <div className="hc-treatment-nav-container">
        <h2>Explore Our Treatments</h2>
        <div className="hc-treatment-nav-cards">
          {treatments.map((treatment) => (
            <div
              key={treatment.name}
              className={`hc-treatment-nav-card ${
                activeTab === treatment.name ? "active" : ""
              }`}
              style={{
                position: "relative",
                borderBottom:
                  activeTab === treatment.name ? "3px solid #007bff" : "none",
                transition: "border-bottom 0.3s ease",
              }}
              onClick={() => handleTreatmentClick(treatment)}
            >
              <div className="hc-card-icon">
                {renderTreatmentIcon(treatment.navName)}
              </div>
              <div
                className="hc-card-title"
                style={{
                  color: ["GROHAIR", "PRP", "GFC", "STM", "LASER"].includes(
                    treatment.navName
                  )
                    ? "#007bff"
                    : "black",
                }}
              >
                {treatment.name.replace(" TREATMENT", "")}
                <span style={{ color: "black" }}> TREATMENT</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hc-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="hc-hero-content">
          <h1 className="hc-hero-title">
            Revolutionary Laser Therapy for Hair Restoration
          </h1>
          <p className="hc-hero-text">
          Experience the benefits of precision laser technology designed to revitalize the scalp and enhance hair thickness.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="hc-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      {/* Unique Treatment Navigation Tabs */}

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
          <div className="hc-treatment-nav">
            <h2>Strengthen Your Hair with Our Advanced Laser Treatments</h2>
            <p className="hc-nav-description">
              Our advanced laser therapy activates hair follicles and improves scalp microcirculation to support natural hair regrowth. This non-invasive treatment reinforces existing hair strands and enhances overall scalp health and density.
            </p>
            <ul>
              <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
              </li>
              <li className="hc-active">
                <strong>Growth Factor Concentrate</strong>
                <p>Stimulate hair follicles & helps in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>
                    Enrich with Biotin , Zinc , Minerals and other Vitamins
                  </li>
                </ul>
              </li>
              <li>
                <strong> Gfc Therapy</strong>
                <p>
                  Restore your hair naturally by plasma rich protein therapy.
                </p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>

              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Based on plant poly peptides </li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="hc-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced
              specialists.
            </p>
            <p className="hc-treatment-extra-info">
              Book a consultation today to create your personalized treatment
              plan.
            </p>
          </div>

          <div className="hc-treatment-content">
            <h3> Advanced Laser Treatment</h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src={laser1}
                  alt="Growth Factor Treatment Process"
                  className="hc-main-treatment-image"
                />
                <div className="hc-treatment-gallery">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.src}
                      alt={image.alt}
                      onClick={() => openModal(image)}
                    />
                  ))}
                </div>
                <div className="hc-treatment-highlight-info">
                 Looking for an effective way to reduce hair fall and improve overall hair density? At H-Cura Multispeciality Clinic, we offer advanced Low-Level Laser Hair Therapy (LLLT) in Bangalore and Chennai, designed to stimulate weakened hair follicles, improve scalp circulation, and encourage natural hair regrowth.

Using medically tested low-intensity laser light, this non-invasive, painless procedure strengthens existing strands, enhances follicular activity, and supports long-term hair restoration. Our clinical specialists use precision-controlled laser technology to deliver safe, consistent, and visible results—without injections, discomfort, or downtime.
                </div>
              </div>

              <div className="hc-treatment-description">
  <h4>Advanced Laser Technology for Hair Restoration</h4>

  <div className="hc-treatment-intro">
    <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
      <span className="hc-highlight-tag">INNOVATIVE LASER</span>
    </Link>
    <p className="hc-lead-text">
      Our precision laser system activates scalp rejuvenation, strengthens follicle activity, and promotes healthy hair growth — without discomfort or invasive procedures.
    </p>
  </div>

  <div className="hc-key-benefits">
    <h5>Clinical Benefits of Laser Hair Therapy</h5>
    <p>
      Our low-level laser technology is designed to:
    </p>

    <ul>
      <li>
        <span className="hc-benefit-icon">🔬</span>
        <strong>Revitalize Dormant Follicles</strong>
        <p>Gently stimulates inactive follicles through a painless, light-based approach.</p>
      </li>

      <li>
        <span className="hc-benefit-icon">📈</span>
        <strong>Improve Hair Density</strong>
        <p>Enhances blood flow and encourages stronger follicular activity.</p>
      </li>

      <li>
        <span className="hc-benefit-icon">🌱</span>
        <strong>Support Natural Regrowth</strong>
        <p>Promotes a healthier hair cycle with consistent laser stimulation.</p>
      </li>

      <li>
        <span className="hc-benefit-icon">💪</span>
        <strong>Strengthen Existing Hair</strong>
        <p>Helps reinforce hair shafts and improve overall scalp vitality.</p>
      </li>
    </ul>
  </div>

  <div className="hc-treatment-highlights">
    <div className="hc-highlight-box">
      <h5>Client Success Rate</h5>
      <p>95%</p>
      <span className="hc-subtitle">Satisfied Patients</span>
    </div>

    <div className="hc-highlight-box">
      <h5>Results</h5>
      <p>6–10 sessions</p>
      <span className="hc-subtitle">For Noticeable Improvement</span>
    </div>

    <div className="hc-highlight-box">
      <h5>Session Duration</h5>
      <p>60 mins</p>
      <span className="hc-subtitle">Per Treatment</span>
    </div>

    <div className="hc-highlight-box">
      <h5>Recovery</h5>
      <p>Minimal</p>
      <span className="hc-subtitle">Resume Routine Immediately</span>
    </div>
  </div>

  <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
    <button className="hc-book-treatment-btn">
      Schedule Your Consultation
      <span className="hc-btn-icon">→</span>
    </button>
  </Link>
</div>

            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
     <section className="hc-benefits-section">
  <div className="hc-benefits-header">
    <span className="hc-section-tag">Why Choose Us</span>
    <h2>Clinical Excellence in Advanced Hair Restoration</h2>
    <p className="hc-section-subtitle">
      Our evidence-based laser treatments combine modern medical technology with
      individualized care to help you achieve healthier, fuller, and more resilient hair.
    </p>
  </div>

  <div className="hc-benefits-grid">
    {[
      {
        icon: "🔬",
        title: "Advanced Laser Technology",
        desc: "We use the latest advancements in low-level laser and growth-stimulation science to support safe, natural hair restoration.",
        features: [
          "Research-Driven Treatment Methods",
          "FDA-Compliant Laser Systems",
          "Clinically Supported Outcomes",
        ],
      },
      {
        icon: "👨‍⚕",
        title: "Experienced Medical Specialists",
        desc: "Our clinical team consists of trained experts in hair and scalp health committed to delivering high-quality patient care.",
        features: [
          "Specialized Hair Restoration Experts",
          "Extensive Clinical Experience",
          "Focused, Personalized Guidance",
        ],
      },
      {
        icon: "🎯",
        title: "Individualized Treatment Plans",
        desc: "Each therapy program is designed according to your scalp condition, hair density, and restoration goals.",
        features: [
          "Customized Laser Sessions",
          "Regular Progress Monitoring",
          "Optimized Treatment Frequency",
        ],
      },
      {
        icon: "✨",
        title: "Natural and Predictable Outcomes",
        desc: "Laser therapy promotes gradual, natural-looking improvements in hair volume and scalp health.",
        features: [
          "Subtle, Realistic Improvements",
          "Sustained Long-Term Benefits",
          "Enhanced Hair Quality",
        ],
      },
      {
        icon: "🛡",
        title: "Strict Clinical Safety Standards",
        desc: "All procedures adhere to medical-grade hygiene and safety protocols to ensure a sterile, controlled treatment environment.",
        features: [
          "Clinical-Grade Facilities",
          "Rigorous Sterilization Procedures",
          "Patient-Focused Care Practices",
        ],
      },
      {
        icon: "💯",
        title: "Proven Patient Outcomes",
        desc: "Thousands of patients have achieved visible improvements in hair density and scalp condition through our laser programs.",
        features: [
          "Over 5,000 Successfully Treated Patients",
          "Verified Clinical Improvements",
          "High Satisfaction and Success Rates",
        ],
      },
    ].map((benefit, index) => (
      <div className="hc-benefit-card" key={index}>
        <div className="hc-benefit-icon">{benefit.icon}</div>
        <div className="hc-benefit-content">
          <h3>{benefit.title}</h3>
          <p>{benefit.desc}</p>
          <ul className="hc-feature-list">
            {benefit.features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
</section>


      {/* Process Section */}
    <section className="hc-process-section" id="process">
  <div className="hc-process-header">
    <span className="hc-process-tag">Our Process</span>
    <h2>Your Clinical Pathway to Improved Hair Density</h2>
    <p className="hc-process-subtitle">
      Follow our structured, evidence-based 4-step protocol designed to ensure
      safe, predictable, and long-lasting laser hair restoration results.
    </p>
  </div>

  <div className="hc-process-timeline">
    {[
      {
        step: "01",
        title: "Comprehensive Scalp Assessment",
        desc: "Your treatment begins with a detailed evaluation of scalp health, hair density, and contributing factors.",
        details: [
          "In-depth scalp and follicle examination",
          "Review of medical and lifestyle history",
          "Identification of treatment requirements",
          "Clear explanation of expected outcomes",
        ],
        icon: "🔍",
      },
      {
        step: "02",
        title: "Personalized Laser Treatment Plan",
        desc: "A tailored laser therapy protocol is created based on your clinical findings and restoration goals.",
        details: [
          "Customized treatment strategy",
          "Selection of optimal laser settings",
          "Structured session planning",
          "Supportive lifestyle guidance",
        ],
        icon: "📋",
      },
      {
        step: "03",
        title: "Precision Laser Therapy Session",
        desc: "Low-level laser energy is applied using controlled, targeted methods to stimulate follicular activity.",
        details: [
          "Clean and sterile preparation",
          "Accurate laser positioning",
          "Focused activation of weak follicles",
          "Comfortable, non-invasive procedure",
        ],
        icon: "💉",
      },
      {
        step: "04",
        title: "Ongoing Monitoring & Aftercare",
        desc: "Your progress is reviewed regularly to ensure consistent improvement and optimal treatment response.",
        details: [
          "Scheduled progress evaluations",
          "Adjustments based on clinical response",
          "Maintenance and booster guidance",
          "Continuous clinical support",
        ],
        icon: "📈",
      },
    ].map((process, index) => (
      <div className="hc-process-step" key={index}>
        <div className="hc-step-container">
          <div className="hc-step-number-container">
            <div className="hc-step-number">{process.step}</div>
            <div className="hc-step-icon">{process.icon}</div>
          </div>
          <div className="hc-step-content">
            <h3>{process.title}</h3>
            <p className="hc-step-description">{process.desc}</p>
            <ul className="hc-step-details">
              {process.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        </div>
        {index < 3 && <div className="hc-connector-line"></div>}
      </div>
    ))}
  </div>
</section>

            <AutoScrollImageRow />


      {/* Modal for Image Viewing */}
      {isModalOpen && (
        <div className="hc-modal-overlay" onClick={closeModal}>
          <div
            className="hc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="hc-close-modal" onClick={closeModal}>
              &times;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="hc-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Laserhair;
